<template>
  <div class="container">
    <div class="cashapp-container">
      <img src="@/assets/google_pay_title.jpg" class="google-title" alt="google pay">
      
      <div class="apple-pay-desc">
        <h2>Use Google Pay</h2>
        <p>google Pay is an easy and secure way to pay. Simply tap Buy with Google Pay and complete your purchase without the need to add to a cart or fill out a form.</p>
      </div>
    </div>

    <div class="amount-container">
      <div class="order-details">
        <div class="amount-row">
          <span class="label">Amount:</span>
          <span class="value">$ {{ (amount/100).toFixed(2) }} </span>
        </div>
        <div class="divider"></div>
        <div class="order-row">
          <span class="label">Order Id:</span>
          <span class="id">{{ orderId }}</span>
        </div>
      </div>
    </div>

    <form id="payment-form">
      <div id="payment-element" class="google-frame"></div>
      <div id="error-message" style="text-align: center;"></div>
    </form>

    <!--<div class="apple-pay-btn" @click.stop="handlePayment">
      <img src="@/assets/btn_apple.png" class="apple-logo" alt="apple pay">
    </div>-->
  </div>
</template>
<script src="https://cdn.payermax.com/dropin/js/pmdropin.min.js"></script>
<script>
// import { payermax } from '@payermax/payermax-js';
import apiClient,  {API_URL_CREATE_ORDER,API_URL_QUERY_ORDER,API_URL_CREATE_PAYMENT,API_URL_DROP_IN_PAYMENT}  from '@/services/api'; // 引入封装好的 HTTP 请求

export default {
  data() {
    return {
      stripe: null,
      clientKey: null,
      sessionKey: null,
      elements: null,
      amount: null,  // 从 URL 查询参数中获取传入的 amount
      encryptedString: this.$route.params.encryptedString,  // 从 URL 获取加密串
      orderId: null, // 从 URL 查询参数中获取传入的 orderId
      payType: null,
      errorMsg: null,
      returnUrl: null,
      wayCode: null,
      platformWebsite: null,
      randomNo: null,
      redirectUrl: null
    };
  },
  async mounted() {
    document.title = 'Payment Center';
    try {
      const response = await apiClient.post(API_URL_CREATE_PAYMENT, {
        encryptedString: this.encryptedString
      });
      this.clientKey = response.data.clientKey;
      this.sessionKey = response.data.sessionKey;
      this.amount = response.data.amount;
      this.orderId = response.data.orderId;
      this.wayCode = response.data.wayCode;
      this.platformWebsite = response.data.platformWebsite;
      this.payType = response.data.payType;
      this.errorMsg = response.data.errorMsg;
      this.returnUrl = response.data.returnUrl;
      this.randomNo = Math.random().toString(36).slice(-8);
      if(this.errorMsg === ''){
      // 实例化一个卡组件
      var card = PMdropin.create('googlepay', {
        // 填入你在服务端获取到的 clientKey
        clientKey: this.clientKey,
        // 填入你在服务端获取到的 sessionKey
        sessionKey: this.clientKey,
        isRtl: true,
        language: "en",
        customLocalization: {
          // 添加中文示例
        },
        //theme:'red',
        customTheme: [
          {
            name: 'red',
            // 用于填充底色的样式【可选】
            base: 'light',
            style: `:root {
            --bg-color-input:#33FF33;
            }`
          }],
        // 开启沙盒模式联调
        sandbox: false
      });

      // 将组件挂载到 dom 节点
      card.mount('.google-frame');
      document.getElementById('pay').addEventListener('click', goPay, false);
      }else{
          document.getElementById('error-message').textContent = this.errorMsg;
      }
    } catch (error) {
      console.error('error', error);
      document.getElementById('error-message').textContent = error;
      this.sendOrderInfo(this.orderId,this.randomNo + ' auto payment error',error);
    }
  },
  methods: {
    async goPay() {
       // 将组件设置为不可编辑状态
       card.emit('setDisabled', true);
      // card.emit('addTheme',[{
      //   name:'red'
      // }])
      // 发起组件校验，并返回卡标识
      card.emit('canMakePayment')
        .then(function (response) {
          // 解除不可编辑状态
          card.emit('setDisabled', false);
          console.log("resp:" + response)
          // 成功获取到 response
          if (response.code === 'APPLY_SUCCESS') {
            // 获取卡标识 paymentToken 
            var paymentToken = response.data.paymentToken;
            console.log('token:' + paymentToken)
            // 进行后续支付操作
            /**
             * 这里需要自行请求服务端，实现服务端下单的操作
             * 下单成功后，自行回调到前端，实现APPLY_SUCCESS后面的代码
             * 服务端下单会返回redirectUrl，前端展示该redirectUrl，会引导用户做3ds校验并完成支付
             * **/
             const response = apiClient.post(API_URL_DROP_IN_PAYMENT, {
              encryptedString: this.encryptedString,
              paymentToken: paymentToken,
              sessionKey: sessionKey,
              userAgent: navigator.userAgent
            });
            this.redirectUrl = response.data.redirectUrl;
            if(response.data.redirectUrl){
              window.location = response.data.redirectUrl;
            }
          } else {
            console.log('error: ' + response.msg)
            console.log('code:' + response.code)
          }
        }).catch(function (error) {
          // 解除不可编辑状态
          card.emit('setDisabled', false);
          console.log("error:" + error);
        });
    },
    async orderQuery() {
      const response = await apiClient.post(API_URL_QUERY_ORDER, {
        orderId: this.orderId
      });
      this.state = response.data.state;
      if(this.state === 2){
        window.location = 'https://www.minicadesmobilegames.com/success.html';
      }
    },
    async sendOrderInfo(orderId,submitType,errMsg) {
      try {
        apiClient.post(API_URL_CREATE_ORDER, {
          userAgent: navigator.userAgent,
          orderId: orderId,
          submitType: submitType,
          errMsg: errMsg
        });
      } catch (error) {
        console.error('error:', error);
      }
    },
    async disabledButton() {
      try {
        var payNowButton = document.getElementById('PayNow');
        payNowButton.textContent = 'Please wait.payment processing...';
        payNowButton.disabled = true;
        document.getElementById('ortest').innerHTML = 'If you have not completed the payment and wish to continue using <strong>cashapp</strong> payment, please refresh this page!'; 
      } catch (error) {
        console.error('pay failed:', error);
        document.getElementById('error-message').textContent = error;
        this.sendOrderInfo(this.orderId,this.randomNo + ' disabledButton error',error);
      }
    },
    async enabledButton() {
      try {
        var payNowButton = document.getElementById('PayNow');
        var i = 3;
        var interval = setInterval(function() {
          if(i>0){
          payNowButton.textContent = 'The order is being pulled up, you can click on payment again in '+i+' seconds';
          i--;
          }else{
            payNowButton.textContent = 'Cash APP Pay';
            clearInterval(interval);
          }
        }, 1000);
        payNowButton.disabled = false;
        document.getElementById('ortest').innerHTML = ''; 
      } catch (error) {
        console.error('pay failed:', error);
        document.getElementById('error-message').textContent = error;
        this.sendOrderInfo(this.orderId,this.randomNo + ' enabledButton error',error);
      }
    },
  },
};
</script>

<style scoped>
/* 新增外层容器 */
.container {
  max-width: 100%;
  min-height: 100vh;
  background-color: #0000;
}

.cashapp-container {
  max-width: 400px;
  margin: 20px auto 0px auto;
  padding: 30px 25px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  font-family: -apple-system, BlinkMacSystemFont, sans-serif;
}

.amount-container {
  max-width: 450px;
  margin: 0 auto;
  padding: 0px 0px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  font-family: -apple-system, BlinkMacSystemFont, sans-serif;
}


/* 按钮样式 */
.apple-pay-btn {
  max-width: 450px;
  margin:20px auto;
  padding: 0px 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 56px;
  background: #0A0A0A;
  border-radius: 8px;
  cursor: pointer;
  transition: opacity 0.2s;
}
.apple-pay-btn:hover {
  opacity: 0.9;
}

/* 居中文字 */
.apple-pay-desc {
  text-align: center;
}
.apple-pay-desc h2 {
  font-size: 18px;
  margin: 0 0 12px 0;
  color: #0A0A0A;
}
.apple-pay-desc p {
  color: #666;
  line-height: 1.5;
  margin: 8px 0;
  font-size: 14px;
  color: #929292;
}


/* 订单信息样式 */
.order-details {
  background: #fff;
  border-radius: 8px;
  margin:7px 0;
  color: #929292;
  padding: 13px 0px;
}

.amount-row, .order-row {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 3px 15px;
}

.label {
  color: #929292;
  font-size: 16px;
}

.value {
  color: #0A0A0A;
  font-weight: 600;
  font-size: 18px;
  padding: 0px 5px;
}

.id {
  color: #929292;
  font-size: 14px;
  padding: 0px 5px;
}

.divider {
  height: 1px;
  background-color: #eee;
  margin: 12px 0;
}

.apple-logo {
  width: auto;
  height: 24px;
}

/* 错误信息样式 */
#error-message {
  color: red;
  margin-top: 10px;
}

/* 标题图片 */
.apple-title {
  display: block;
  margin: 0 auto 20px;
  width: 120px;
}
</style>